module.exports = __webpack_public_path__ + "static/media/daily_dating_popup_message_img.937c5fff.png";